import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    pairingTemplates: [],
    pairingTemplatesMetadata: {},
    pairingTemplate: {}
  }
})
  .get({
    queryParams: true,
    action: 'getPairingTemplates',
    property: 'pairingTemplates',
    path: '/pairing-templates/',
    onSuccess: payloadToState('pairingTemplates')
  })
  .post({
    action: 'createPairingTemplate',
    property: 'pairingTemplate',
    path: '/pairing-templates/',
    onSuccess: payloadToState('pairingTemplate')
  })
  .post({
    action: 'updatePairingTemplate',
    property: 'pairingTemplate',
    path: ({ id }) => `/update-pairing-templates/${id}`,
    onSuccess: payloadToState('pairingTemplate')
  })
  .get({
    action: 'getPairingTemplate',
    property: 'pairingTemplate',
    path: ({ id }) => `/pairing-templates/${id}`,
    onSuccess: payloadToState('pairingTemplate')
  })
  .delete({
    action: 'deletePairingTemplate',
    property: 'pairingTemplate',
    path: ({ id }) => `/pairing-templates/${id}`,
    beforeRequest: getOptimisticDelete('pairingTemplates'),
    onSuccess: payloadToState('pairingTemplate')
  })
  .delete({
    action: 'deletePairingTemplates',
    property: 'pairingTemplates',
    path: `/pairing-templates/`,
    queryParams: true,
    beforeRequest: getOptimisticDelete('pairingTemplates'),
    onSuccess: payloadToState('pairingTemplates')
  })
  .getStore()
